export default "__VITE_ASSET__I8l5r0X2__"